import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Mail, Download } from "lucide-react";

export default function NewsletterPage() {
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/newsletter")
      .then((r) => setSubs(r.data))
      .finally(() => setLoading(false));
  }, []);

  const exportCSV = () => {
    const csv = ["email,created_at", ...subs.map((s) => `${s.email},${s.created_at}`)].join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `newsletter-${Date.now()}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="admin-newsletter" className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div>
          <div className="font-jp text-yellow-400 text-xs tracking-widest mb-2">クラブ会員</div>
          <h1 className="font-heading text-5xl uppercase text-white leading-none">Newsletter</h1>
          <p className="text-zinc-400 mt-2">{subs.length} iscritti al Drop Club.</p>
        </div>
        <button data-testid="export-csv-button" onClick={exportCSV} disabled={subs.length === 0}
          className="bg-yellow-400 text-black font-heading uppercase px-6 py-3 hover:bg-white transition flex items-center gap-2 disabled:opacity-40">
          <Download className="w-5 h-5" strokeWidth={3} /> Esporta CSV
        </button>
      </div>

      <div className="bg-zinc-900 border-2 border-zinc-800 overflow-x-auto">
        <table className="w-full">
          <thead className="bg-zinc-950 border-b-2 border-zinc-800">
            <tr className="text-left">
              <th className="font-heading uppercase text-yellow-400 text-xs tracking-widest p-3">Email</th>
              <th className="font-heading uppercase text-yellow-400 text-xs tracking-widest p-3">Iscritto il</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={2} className="p-8 text-center text-zinc-500 uppercase">Caricamento...</td></tr>}
            {!loading && subs.length === 0 && <tr><td colSpan={2} className="p-8 text-center text-zinc-500 uppercase">Nessun iscritto</td></tr>}
            {subs.map((s) => (
              <tr key={s.id} data-testid={`subscriber-row-${s.id}`} className="border-b border-zinc-800 hover:bg-zinc-950/50">
                <td className="p-3"><div className="flex items-center gap-2 text-white"><Mail className="w-4 h-4 text-yellow-400" strokeWidth={3} /> {s.email}</div></td>
                <td className="p-3 text-zinc-400 text-sm">{new Date(s.created_at).toLocaleString("it-IT")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
